import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";
import styled from "styled-components";
import { useCreateElementContext } from "../Context/CreateElementContext";
import AddLanguageDialog from "../../AddLanguageDialog";
import { setStatus } from "../../../../store/actions/User";
import { useDispatch } from "react-redux";
import { ErrorLabel } from "../../ElementForm";
import FormComponent from "../../../Common/FormComponent/FormComponent";
import {
  assessmentDetails,
  videoConfig,
  videoDurationConfig,
} from "../../constants";
import Label from "../../../Common/Label/Label";
import UploadVideoWrapper from "../../VideoUploadWrapper";
import VideoUploader from "../../../Common/VideoUploader";
import {
  convertToTime,
  getVideoDurationByURL,
  videoRegex,
  videoUrlRegex,
} from "../../../../utils/video";

const VideoContent = ({}) => {
  const {
    form,
    options,
    element_type,
    handleVideoImage,

    handleAdd,
    handleDelete,
    makeDefaultLanguage,
  } = useCreateElementContext();
  const dispatch = useDispatch();

  const handleVideoUrl = (index, key) => async (e) => {
    const value = e.target.value;

    if (videoUrlRegex.test(value)) {
      try {
        form.handleValue(`content.${index}.url`, {
          regex: videoRegex,
          errorMessage: "The URL not seems to be a valid video URL",
        })(value);
        const duration = await getVideoDurationByURL(value);
        form.setFields((prev) => {
          prev.content[index].duration = convertToTime(duration);
          return { content: [...prev.content] };
        });
      } catch (err) {
        dispatch(
          setStatus({
            message: "Enter a valid url video",
            type: "error",
          })
        );
      }
    } else {
      form.setFields((prev) => {
        prev.content[index].url = value;
        return { content: [...prev.content] };
      });
      dispatch(
        setStatus({
          message: "Enter a valid url",
          type: "error",
        })
      );
    }
  };

  const handleSelect = (language) => {
    const languagesAlreadyAdded = form?.values?.content?.map(
      (item) => item.lang_code
    );

    if (languagesAlreadyAdded.includes(language)) {
      dispatch(
        setStatus({
          message:
            "this language is already added, please select a different language",
          type: "error",
        })
      );
    } else {
      handleAdd(language);
      dispatch(
        setStatus({
          message: "language added",
          type: "success",
        })
      );
    }
  };
  return (
    <Box display={"flex"} flex={1} flexDirection={"column"} gap={2} mt={2}>
      <BorderedBox display={"flex"} flexDirection={"column"} gap={2}>
        {form.values?.content?.map((item, index) => (
          <Box
            borderBottom={"4px solid #F5F5F5"}
            pb={3}
            display={"flex"}
            flex={1}
            flexDirection={"column"}
            gap={2}
            key={`${index}`}
            position={"relative"}
          >
            {index !== 0 && (
              <Box
                sx={{
                  position: "absolute",
                  right: 0,
                  top: 0,
                  display: "flex",
                  gap: 2,
                }}
              >
                <Button
                  variant="text"
                  color="error"
                  onClick={() => makeDefaultLanguage(index)}
                >
                  Mark it as default language
                </Button>
                <Button
                  variant="text"
                  color="error"
                  onClick={() => handleDelete(index)}
                >
                  Delete
                </Button>
              </Box>
            )}
            <Typography
              variant="h6"
              color="GrayText"
              sx={{ textTransform: "uppercase", letterSpacing: 3 }}
            >
              CONTENT:{" "}
              {
                options?.languages?.find(
                  (lang) => lang.value === item.lang_code
                )?.label
              }{" "}
              {index === 0 && "(DEFAULT)"}
            </Typography>
            {<ErrorLabel label={form.errors.content} />}
            <Box display={"flex"} gap={4}>
              <Box display={"flex"} gap={2} flexDirection={"column"} flex={1}>
                {videoConfig
                  .map((item) => ({
                    ...item,
                    id: `content.${index}.${item.id}`,
                  }))
                  .map((item) => (
                    <Box>
                      <FormComponent
                        config={item}
                        form={form}
                        key={item.id}
                        otherOptions={
                          options[item?.props?.optionsKey ?? item.id]
                        }
                      />
                      <ErrorLabel label={form.errors[item.id]} />
                    </Box>
                  ))}
              </Box>
              <Box display={"flex"} gap={2} alignItems={"center"} flex={1}>
                <Box display={"flex"} flexDirection={"column"} gap={2}>
                  <Label>Upload Video</Label>
                  <UploadVideoWrapper
                    UploadComponent={VideoUploader}
                    onUpload={handleVideoImage(index)}
                    url={form.getValue(`content.${index}.url`)}
                  />
                </Box>
                <Box display={"flex"} flexDirection={"column"} gap={2}>
                  <Label>Or add a video CDN URL</Label>
                  <TextField
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "8px !important",
                      },
                    }}
                    onChange={handleVideoUrl(index, `content.${index}.url`)}
                    value={form.getValue(`content.${index}.url`)}
                    variant="outlined"
                    placeholder="CDN URL"
                  />
                  <ErrorLabel label={form.errors[`content.${index}.url`]} />

                  {form.getValue(`content.${index}.url`) &&
                    videoDurationConfig
                      .map((item) => ({
                        ...item,
                        id: `content.${index}.${item.id}`,
                        props: {
                          ...item.props,
                          disabled: !form.getValue(`content.${index}.url`),
                        },
                      }))
                      .map((item) => (
                        <Box>
                          <FormComponent
                            config={item}
                            form={form}
                            key={item.id}
                            otherOptions={
                              options[item?.props?.optionsKey ?? item.id]
                            }
                          />
                          <ErrorLabel label={form.errors[item.id]} />
                        </Box>
                      ))}
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </BorderedBox>
      <AddLanguageDialog
        options={options.languages}
        title={
          form?.values?.content?.length === 0
            ? "Add a default language"
            : "Add additional language"
        }
        onSelect={handleSelect}
      />{" "}
      {form?.values?.content?.length === 0 && (
        <Box textAlign={"center"}>
          <ErrorLabel label={form.errors.content} />
        </Box>
      )}
    </Box>
  );
};

export default VideoContent;

const BorderedBox = styled(Box)`
  background: #fcfcfc;
  border: 1px solid #cfcfcf;
  box-sizing: border-box;
  border-radius: 12px;
  padding: 30px;
`;
